module.exports = __webpack_public_path__ + "img/beans_jurassic.fx.45a0cd4.png";